import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { fonts, sizes } from '@/design-system/Typography/Typography.styles';
import { pxToRem } from '@/utils';

const styles = {
  container: css`
    padding: 16px;
    display: flow-root;
    div {
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        color: ${colors.midnight};
        display: block;
      }

      h1 {
        font-family: ${fonts.bold};
        font-size: ${sizes.xxl};
        line-height: ${pxToRem(34)};
      }

      h2 {
        font-family: ${fonts.medium};
        font-size: ${sizes.xl};
        font-weight: 700;
        line-height: ${pxToRem(28)};
      }

      h3 {
        font-family: ${fonts.medium};
        font-size: ${sizes.lg};
        font-weight: 700;
        line-height: ${pxToRem(25)};
      }
      h4,
      h5 {
        font-family: ${fonts.medium};
        font-weight: 700;
      }

      h1 + *,
      h2 + *,
      h3 + *,
      h4 + *,
      h5 + *,
      p + *,
      div + *,
      ul + *,
      p + *,
      main + *,
      section + *,
      footer {
        margin-top: 8px;
      }

      header,
      footer {
        margin-bottom: 8px;
      }

      strong {
        font-family: ${fonts.bold};
        font-size: ${sizes.sm};
        color: ${colors.midnight};
        line-height: ${pxToRem(20)};
      }
      p,
      li {
        font-family: ${fonts.medium};
        color: ${colors.midnight};
        font-size: ${sizes.sm};
        line-height: ${pxToRem(20)};
      }
      a {
        font-family: ${fonts.medium};
        font-size: ${sizes.sm};
        line-height: ${pxToRem(20)};
        color: ${colors.shadesJungle700};
        text-decoration: underline;
      }
      a:not([href]) {
        color: ${colors.midnight};
        text-decoration: none;
        cursor: text;
      }
    }
  `,
  tag: css`
    margin-bottom: 16px;
  `,
  blurredContent: css`
    filter: blur(2px);
  `,
};

export default styles;
